{
  "planReady": {
    "title": "您的计划已就绪",
    "body": "{{name}} — 请查阅生成的计划。"
  },
  "dataIngestComplete": {
    "title": "您的文件已就绪",
    "body": "{{name}} — 已处理 {{count}} 个文件。"
  },
  "completenessReady": {
    "title": "数据检查已完成",
    "body": "{{name}} — 您已可开始生成。"
  },
  "completenessNeedsData": {
    "title": "数据检查已完成",
    "body": "{{name}} — 缺少部分数据。请查看所需内容。"
  },
  "sectionsReady": {
    "title": "您的章节已就绪",
    "body": "{{name}} — 已生成 {{count}} 个章节。可供审阅。"
  },
  "validationComplete": {
    "title": "自检已完成",
    "body": "{{name}} — 请查阅已自检的报告。"
  },
  "planRevisionComplete": {
    "title": "计划已更新",
    "body": "{{name}} — 请查阅修订后的计划。"
  },
  "failure": {
    "title": "有事项需要您处理",
    "body": "{{name}} — {{stage}} 未能完成。请打开 Bennie 重试。"
  },
  "stageNames": {
    "planGeneration": "计划生成",
    "dataIngest": "数据接入",
    "completenessCheck": "完整性检查",
    "sectionGeneration": "章节生成",
    "validation": "自检",
    "planRevision": "计划修订"
  },
  "extractorComplete": {
    "title": "模型提取已完成",
    "body": "{{target}} — 模型提取已就绪。"
  },
  "extractorFailed": {
    "title": "模型提取未能完成",
    "body": "{{target}} — 请打开 Bennie 查看出错原因。"
  },
  "gatekeeperComplete": {
    "title": "守门员检查已完成",
    "body": "{{target}} — 结果已出。"
  },
  "gatekeeperFailed": {
    "title": "守门员检查未能完成",
    "body": "{{target}} — 请打开 Bennie 查看出错原因。"
  }
}
